var render, staticRenderFns
import script from "./BasicBarChart.vue?vue&type=script&lang=js"
export * from "./BasicBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d23a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9d23a2')) {
      api.createRecord('2b9d23a2', component.options)
    } else {
      api.reload('2b9d23a2', component.options)
    }
    
  }
}
component.options.__file = "src/components/Charts/BasicBarChart.vue"
export default component.exports